import API from '@/api/index';
import moment from 'moment';
import * as Auth from '../../utils/auth';
import store from '@/store';

const crmBitrix = {
  state: {
    userGroup: []
  },

  mutations: {
    SET_USER_GROUP: (state, data) => {
      state.userGroup = data;
    }
  },

  actions: {
    BitrixContactsRequest ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.crmBitrix
          .BitrixContactsRequest(data)
          .then(response => {
            let result = response.data;
            if (!result.Code && result.Data) {
              resolve(result.Data);
            }
            else { reject(result) }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    BitrixTicketsRequest ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.crmBitrix
          .BitrixTicketsRequest(data)
          .then(response => {
            let result = response.data;
            if (!result.Code && result.Data) {
              resolve(result.Data);
            }
            else { reject(result) }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    ExportTicketsBySupporter ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.crmBitrix
          .ExportTicketsBySupporter(data)
          .then(response => {
            let result = response.data;
            if (!result.Code && result.Data) {
              resolve(result.Data);
            }
            else { reject(result) }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    GetUserGroup ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.crmBitrix
          .GetUserGroup(data)
          .then(response => {
            let result = response.data;
            if (!result.Code && result.Data) {
              commit('SET_USER_GROUP', result.Data);
              resolve(result.Data);
            }
            else { reject(result) }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    GetTicketByDate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.crmBitrix
          .GetTicketByDate(data)
          .then(response => {
            let result = response.data;
            if (!result.Code && result.Data) {
              store.commit('APPEND_CASES', result.Data);
              resolve(result.Data);
            }
            else { reject(result) }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    GetAllTicket ({ commit }) {
      return new Promise((resolve, reject) => {
        API.crmBitrix
          .GetAllTicket()
          .then(response => {
            let result = response.data;
            if (!result.Code && result.Data) {
              store.commit('APPEND_CASES', result.Data);
              resolve(result.Data);
            }
            else { reject(result) }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    GetAllTechnicalUser ({ commit }) {
      return new Promise((resolve, reject) => {
        API.crmBitrix
          .GetAllTechnicalUser()
          .then(response => {
            let result = response.data;
            if (!result.Code && result.Data) {
              store.commit('APPEND_SUPPORTERS', result.Data);
              resolve(result.Data);
            }
            else { reject(result) }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    GetTicketNotAssign ({ commit }) {
      return new Promise((resolve, reject) => {
        API.crmBitrix
          .GetTicketNotAssign()
          .then(response => {
            let result = response.data;
            if (!result.Code && result.Data) {
              resolve(result.Data);
            }
            else { reject(result) }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    TicketDispatchCrmBitrix ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.crmBitrix
          .TicketDispatchCrmBitrix(data)
          .then(response => {
            let result = response.data;
            if (!result.Code && result.Data) {
              resolve(result.Data);
            }
            else { reject(result) }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    ReturnTicket ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.crmBitrix
          .ReturnTicket(data)
          .then(response => {
            let result = response.data;
            if (!result.Code && result.Data) {
              resolve(result.Data);
            }
            else { reject(result) }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    PushTicketNotAssign ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.crmBitrix
          .PushTicketNotAssign(data)
          .then(response => {
            let result = response.data;
            if (!result.Code && result.Data) {
              resolve(result.Data);
            }
            else { reject(result) }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};

export default crmBitrix;



// WEBPACK FOOTER //
// ./src/store/modules/crm-bitrix.js